import React from 'react';
import classNames from 'classnames';
import { Chip, ChipProps } from '@mui/material';
import styles from './card-status-tag.module.scss';

export interface CardStatusTagProps extends Omit<ChipProps, 'label'> {
    label: string;
    isActive?: boolean;
}

export const CardStatusTag: React.FC<CardStatusTagProps> = ({ label, isActive = true, className, classes, ...rest }) => {
    return (
        <Chip
            {...rest}
            label={label}
            className={classNames(styles.statusTag, isActive ? styles.active : styles.inactive, className)}
            classes={{
                label: styles.label,
                ...classes,
            }}
        />
    );
};

export default CardStatusTag;
